export default __webpack_public_path__ + "static/media/bus-station.4363a6c1.svg";